import { BundleServices, BundleServicesKey } from "../../Evaluators/DomainServices/DomainServiceEnumItemsExpressionEvaluator";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { MaybePromise } from "../../../Models/MaybePromise";
import { NavigateToExpression } from "../../../Models/UserInterfaces/NavigateToExpression";
import { buildRoutePath, NavigationService } from "../../../../UserInterfaceModule/Services/NavigationService";

export class NavigateToExpressionEvaluator implements IExpressionEvaluator<NavigateToExpression> {
    get type(): string {
        return "UserInterface.NavigateTo";
    }

    evaluate(expression: NavigateToExpression, context: IExpressionEvaluatorContext): MaybePromise {
        const navigationService = context.GetProperty<NavigationService>(NavigationService.KEY);

        if (expression.RoutePath) {
            // navigate by RoutePath directly, without resolving a ViewId - this allows navigating to external routes or ones not associated with a specific view
            navigationService.navigate(expression.RoutePath);
            return true;
        }

        if (expression.ViewId) {
            // navigate using a ViewId - this requires looking up the view's RoutePath from the bundle, but allows for more decoupling and flexibility in navigation
            const { bundle } = context.GetProperty<BundleServices>(BundleServicesKey);
            const view = bundle.ViewById[expression.ViewId];

            if (!view?.RoutePath) {
                console.warn(`[NavigateToExpressionEvaluator] View '${expression.ViewId}' not found or has no RoutePath.`);
                return true;
            }

            const navigate = (input: any) => navigationService.navigate(buildRoutePath(view.RoutePath!, input));

            if (expression.ViewInput) {
                const result = context.Evaluator.evaluate(expression.ViewInput, context);
                if (result instanceof Promise) {
                    return result.then(navigate);
                }
                navigate(result);
            } else {
                navigate(undefined);
            }
        }

        return true;
    }
}
